import React from "react"
import { RecoilRoot } from "recoil"
import ReactDOM from "react-dom"
import App from "./App"
import "utils/i18n"
import * as serviceWorker from "./serviceWorker"
import "./index.css"

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("flag_root")
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
